import React from 'react';
import { generatePath } from 'react-router';
import { useDispatch } from 'react-redux';
import { simpleDate } from '../../../../helpers/datetime';
import { formatPrice } from '../../../../helpers/number';
import Button, { BUTTON_KIND_TRANSPARENT } from '../../../common/buttons/button/Button';
import { ACCOUNT_INVOICE_PERIOD, PAY_NOW_BEDROCK, PAID } from '../../../../constants/Copy';
import { ROUTE_INVOICE } from '../../../../constants/Routes';
import { analyticsPush } from '../../../../actions/applicationActions';
import { EVT_PAY_OPEN_INVOICE_CLICKED_PAY } from '../../../../constants/EventTypes';
import Icon from '../../../common/icons/Icon';
import cx from 'classnames';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_ACCOUNT,
	EVT_INVOICE_DOWNLOAD,
	EVT_ELEMENT_INTERACTION,
	EVT_INVOICE,
	EVT_ICON,
	EVT_MY_INVOICES,
} from '../../../../constants/SnowplowEvents';
import './Invoices.scss';

const InvoiceListItem = ({ invoice, index, showPDFButton, origin }) => {
	const dispatch = useDispatch();
	const paid = invoice.outstandingBalance === 0 || !invoice.openPayments.length;
	return (
		<li key={invoice.number} className="invoices-list-item">
			<section className="invoice" data-test="invoice">
				<header className="invoice__header">
					<p className="invoice__headline">{invoice.headline}</p>
					<p className="invoice__date-text">
						{ACCOUNT_INVOICE_PERIOD}:{' '}
						<time className="invoice__date" dateTime={invoice.serviceStartDate}>
							{simpleDate(invoice.serviceStartDate)}
						</time>{' '}
						-{' '}
						<time className="invoice__date" dateTime={invoice.serviceEndDate}>
							{simpleDate(invoice.serviceEndDate)}
						</time>
					</p>
				</header>
				<div
					className={cx('invoice__amount', {
						['paid-invoice']: paid,
						['pay-invoice']: !paid,
					})}
				>
					&euro;
					{formatPrice(invoice.totalAmount)} | {renderPayInvoiceButton(index, { paid, invoice })}
				</div>
				{showPDFButton && renderViewInvoiceButton(index, invoice.id)}
			</section>
		</li>
	);

	function renderPayInvoiceButton(index, { paid, invoice }) {
		return paid ? (
			<span>{PAID}</span>
		) : (
			<Button
				className="pay-invoice-button"
				data-test={`pay-invoice-button-${index}`}
				onClick={() => handlePayInvoiceClick({ invoice, label: PAY_NOW_BEDROCK })}
			>
				{PAY_NOW_BEDROCK}
			</Button>
		);
	}

	function handlePayInvoiceClick({ invoice, label }) {
		const payLink = invoice.openPayments[0]?.payLink;
		if (payLink) {
			// mijn account page
			window.location.href = `${payLink}&origin=${origin}`;
			dispatch(
				analyticsPush(
					{
						label,
						origin,
					},
					EVT_PAY_OPEN_INVOICE_CLICKED_PAY
				)
			);
			return true;
		}
		return false;
	}

	function renderViewInvoiceButton(index, invoiceId) {
		if (!invoiceId) return null;

		const invoiceRoute = generatePath(ROUTE_INVOICE, { invoiceId });

		return (
			<Button
				data-test={`download-invoice-button-${index}`}
				kind={BUTTON_KIND_TRANSPARENT}
				href={invoiceRoute}
				target="_blank"
				onClick={() => {
					initiateTrackStructEvent({
						category: EVT_ACCOUNT,
						action: EVT_INVOICE_DOWNLOAD,

						rtlElementContext: {
							elementInteraction: EVT_ELEMENT_INTERACTION,
							elementGroup: EVT_INVOICE,
							elementType: EVT_ICON,
							elementName: EVT_MY_INVOICES,
						},
					});
				}}
			>
				<Icon
					className="invoice__download__icon"
					name="download_icon"
					width="12"
					height="12"
					viewBox="0 0 22 22"
				/>
			</Button>
		);
	}
};

export default InvoiceListItem;
